import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { SweetAlertHelper } from '../../../../../../core/helpers/sweet-alert-helper.service';

declare const moment: any;

@Component({
  selector: 'app-start-date-form',
  templateUrl: './start-date-form.component.html',
  styleUrls: ['./start-date-form.component.scss'],
})
export class StartDateFormComponent implements OnInit, OnChanges {
  @Output() startDate = new EventEmitter<any>();
  @Input() modelDatePicker: any = {};
  selectStartDate: any = {};
  myDatePickerOptions: any = {
    dateFormat: 'mm-dd-yyyy',
    editableDateField: false,
    markCurrentDay: false,
  };

  constructor(private sweetAlertHelper: SweetAlertHelper) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['modelDatePicker'] && this.modelDatePicker) {
      this.validDateDay(this.modelDatePicker.beginDate);
      this.validateDate();
    }
  }

  ngOnInit() {
    this.modelDatePicker = {};
  }

  submitFormStanding() {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Are you sure',
      text: 'Are you sure you want to perform this operation?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        if (!this.selectStartDate.formatted) {
          this.selectStartDate
            = `${this.modelDatePicker.beginDate.month}-${this.modelDatePicker.beginDate.day}-${this.modelDatePicker.beginDate.year}`;
          const dateInput = moment(this.selectStartDate).format('MM-DD-YYYY');
          this.startDate.emit(dateInput);
          return;
        }
        this.startDate.emit(this.selectStartDate.formatted);
      }
    });
  }

  validateDate() {
    if (this.modelDatePicker) {
      const beginDate = moment(
        new Date(
          this.modelDatePicker.beginDate.year,
          this.modelDatePicker.beginDate.month - 1,
          this.modelDatePicker.beginDate.day
        )
      );
      const endDate = moment(
        new Date(
          this.modelDatePicker.endDate.year,
          this.modelDatePicker.endDate.month - 1,
          this.modelDatePicker.endDate.day
        )
      );
      const currentDate = moment(new Date());
      const range = moment(currentDate).isBetween(beginDate, endDate);
      if (!range) {
        this.selectStartDate = {
          date: {
            year: this.modelDatePicker.beginDate.year,
            month: this.modelDatePicker.beginDate.month,
            day: this.modelDatePicker.beginDate.day,
          },
        };
      }
    }
  }

  validDateDay(dateSend) {
    let endDay; let mont;
    if (this.modelDatePicker.beginDate.day === 1) {
      let montRecived;
      dateSend.month === 1 ? montRecived = 12 : montRecived = (dateSend.month - 1);
      const beforeDate = `${dateSend.year}-${montRecived}`;
      endDay = moment(beforeDate, 'YYYY-MM').daysInMonth();
      mont = dateSend.month - 1;
    } else {
      endDay = this.modelDatePicker.beginDate.day - 1;
      mont = this.modelDatePicker.beginDate.month;
    }
    this.myDatePickerOptions = {
      disableUntil: {
        year: this.modelDatePicker.beginDate.year,
        month: mont,
        day: endDay,
      },
      disableSince: {
        year: this.modelDatePicker.endDate.year,
        month: this.modelDatePicker.endDate.month,
        day: this.modelDatePicker.endDate.day + 1,
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/edit-standing-order/components/start-date-form/start-date-form.component.ts